export const buildDisplayResultsOptions = (permissions = {}, t = (key, fallback) => fallback) => {
  const {
    allow_financial_report: allowFinancialReport = false,
    allow_franchise_financial_report: allowFranchiseFinancialReport = false,
    hidden_excel_export: hiddenExcelExport = false,
  } = permissions

  const opts = [{ value: "display", label: t("trainees.on_screen", "На экране") }]

  if (allowFinancialReport) {
    opts.push({
      value: "xls_financial",
      label: t("admin.excel_financial", "excel financial"),
    })
  }
  if (allowFranchiseFinancialReport) {
    opts.push({
      value: "xls_financial_franchise",
      label: t("admin.excel_financial_franchise", "excel financial franchise"),
    })
  }
  if (!hiddenExcelExport) {
    opts.push(
      { value: "xls", label: t("admin.excel", "excel") },
      { value: "xls_old", label: t("admin.excel_old", "excel old") },
      { value: "pdf", label: t("admin.pdf", "pdf") }
    )
  }

  return opts
}
